var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { SignInButtonGoogle } from '@web/components/SignIn/SignInButton/SignInButtonGoogle';
import { GOOGLE_CLIENT_ID } from '@web/config';
export var SignInButton = function (props) {
    return (_jsx(GoogleOAuthProvider, __assign({ clientId: GOOGLE_CLIENT_ID }, { children: _jsx(SignInButtonGoogle, __assign({}, props)) })));
};
